/* Exceptional – Halloween VIP-Pop-up (sections/exc-halloween-vip.liquid), Stand 14.10.2026 */
(function(){
  function init(root){
    if (!root || root.getAttribute('data-bound')) { return; }
    root.setAttribute('data-bound', '1');
    if (root.parentNode !== document.body) { document.body.appendChild(root); }

    var KEY = 'exchw_vip_2026';
    var sid = root.getAttribute('data-sid');
    var modal = root.querySelector('.exchw-vip__modal');
    var card = root.querySelector('.exchw-vip__card');
    var teaser = root.querySelector('.exchw-vip__teaser');
    var form = root.querySelector('.exchw-vip__form');
    var email = root.querySelector('.exchw-vip__input');
    var err = root.querySelector('.exchw-vip__err');
    var submitBtn = form.querySelector('.exchw-vip__btn');
    var pic = root.querySelector('.exchw-vip__img');
    var start = Date.parse(root.getAttribute('data-start'));
    var end = Date.parse(root.getAttribute('data-end'));
    var delay = parseInt(root.getAttribute('data-delay'), 10);
    if (isNaN(delay)) { delay = 8; }
    var snooze = (parseInt(root.getAttribute('data-snooze'), 10) || 3) * 864e5;
    var design = root.getAttribute('data-design') === 'true';
    var force = /[?&]exchw_vip=1/.test(window.location.search);
    var fromMail = /utm_source=klaviyo|utm_medium=email/i.test(window.location.search);
    var isOpen = false, timer = null, lastFocus = null, armed = false, armTimer = null;
    var auto = root.getAttribute('data-auto') !== 'false';
    var gates = (root.getAttribute('data-gate') || '').split(',');
    function clean(p){ return (p || '').replace(/^\s+|\s+$/g, '').replace(/\/+$/, '').toLowerCase(); }
    function gated(){ return !isNaN(end) && Date.now() < end; }
    function isGatePath(path){
      var p = clean(path);
      if (!p) { return false; }
      for (var i = 0; i < gates.length; i++) { var g = clean(gates[i]); if (g && (p === g || /^\/[a-z]{2}(-[a-z]{2})?$/.test(p.slice(0, p.length - g.length)) && p.slice(-g.length) === g)) { return true; } }
      return false;
    }
    function openForm(){ view(read().done ? 'done' : 'form'); open(); }
    function onGateClick(e){
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) { return; }
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a || root.contains(a)) { return; }
      var u; try { u = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
      if (u.host !== window.location.host) { return; }
      var hit = u.hash === '#insider' || /[?&]exchw_vip=1/.test(u.search) || (gated() && isGatePath(u.pathname));
      if (!hit) { return; }
      e.preventDefault();
      e.stopPropagation();
      openForm();
    }

    function read(){ try { return JSON.parse(window.localStorage.getItem(KEY) || '{}'); } catch (e) { return {}; } }
    function write(o){ try { window.localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} }
    function pad(n){ return n < 10 ? '0' + n : '' + n; }
    function put(sel, v){ var el = root.querySelector(sel); if (el) { el.textContent = v; } }
    function track(name){
      try { (window.dataLayer = window.dataLayer || []).push({ event: 'exc_halloween_vip', exc_action: name }); } catch (e) {}
      try { if (window.Shopify && window.Shopify.analytics && window.Shopify.analytics.publish) { window.Shopify.analytics.publish('exc_halloween_vip_' + name, {}); } } catch (e) {}
    }
    function lock(on){
      var de = document.documentElement;
      try {
        if (on) {
          var sw = window.innerWidth - de.clientWidth;
          de.classList.add('exchw-vip-lock');
          if (sw > 0) { de.style.paddingRight = sw + 'px'; }
        } else {
          de.classList.remove('exchw-vip-lock');
          de.style.paddingRight = '';
        }
      } catch (e) {}
    }
    function preload(){ try { if (pic) { pic.loading = 'eager'; } } catch (e) {} }
    function tick(){
      var left = Math.max(0, end - Date.now());
      put('[data-d]', pad(Math.floor(left / 864e5)));
      put('[data-h]', pad(Math.floor(left / 36e5) % 24));
      put('[data-m]', pad(Math.floor(left / 6e4) % 60));
      put('[data-s]', pad(Math.floor(left / 1e3) % 60));
    }
    function view(name){
      var els = root.querySelectorAll('[data-view]');
      for (var i = 0; i < els.length; i++) { els[i].hidden = els[i].getAttribute('data-view') !== name; }
    }
    function onKey(e){
      if (e.key === 'Escape' || e.keyCode === 27) { close(); return; }
      if (e.key !== 'Tab') { return; }
      var f = card.querySelectorAll('button:not([disabled]), input, a[href]');
      var list = []; for (var i = 0; i < f.length; i++) { if (f[i].offsetParent !== null) { list.push(f[i]); } }
      if (!list.length) { return; }
      var first = list[0], last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
    function disarm(){
      armed = false; window.clearTimeout(armTimer);
      window.removeEventListener('scroll', onScroll);
      document.documentElement.removeEventListener('mouseleave', onLeave);
    }
    function open(auto){
      if (isOpen) { return; }
      isOpen = true; disarm(); preload();
      lastFocus = document.activeElement;
      teaser.hidden = true; modal.hidden = false; lock(true);
      track(auto === true ? 'view' : 'reopen');
      tick(); timer = window.setInterval(tick, 1000);
      window.requestAnimationFrame(function(){ window.requestAnimationFrame(function(){ root.classList.add('is-open'); }); });
      document.addEventListener('keydown', onKey);
      window.setTimeout(function(){
        if (!isOpen) { return; }
        try { card.focus({ preventScroll: true }); } catch (e) { try { card.focus(); } catch (e2) {} }
      }, 450);
    }
    function close(){
      if (!isOpen) { return; }
      isOpen = false; lock(false);
      root.classList.remove('is-open');
      window.clearInterval(timer);
      document.removeEventListener('keydown', onKey);
      var st = read();
      if (!st.done) { st.closed = Date.now(); write(st); teaser.hidden = false; }
      window.setTimeout(function(){ if (!isOpen) { modal.hidden = true; } }, 320);
      try { if (lastFocus && lastFocus.focus) { lastFocus.focus(); } } catch (e) {}
    }
    function go(){
      if (!armed) { return; }
      disarm();
      var decided = false;
      function decide(known){
        if (decided) { return; }
        decided = true;
        if (known === true) { teaser.hidden = false; } else { open(true); }
      }
      try {
        if (window.klaviyo && typeof window.klaviyo.isIdentified === 'function') {
          /* Antwortet Klaviyo nicht (z. B. Werbeblocker), geht das Pop-up trotzdem auf */
          window.setTimeout(function(){ decide(false); }, 1500);
          window.klaviyo.isIdentified().then(decide, function(){ decide(false); });
          return;
        }
      } catch (e) {}
      decide(false);
    }
    function onScroll(){
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max > 0 && (window.pageYOffset || doc.scrollTop) / max >= 0.3) { go(); }
    }
    function onLeave(e){ if (e.clientY <= 0) { go(); } }

    var closers = root.querySelectorAll('[data-close]');
    for (var c = 0; c < closers.length; c++) { closers[c].addEventListener('click', close); }
    teaser.addEventListener('click', function(){ view(read().done ? 'done' : 'form'); open(); });

    form.addEventListener('submit', function(e){
      e.preventDefault();
      err.hidden = true;
      var val = email.value.replace(/^\s+|\s+$/g, '');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) { err.hidden = false; email.focus(); return; }
      submitBtn.disabled = true;
      var payload = { data: { type: 'subscription', attributes: {
        custom_source: 'Halloween-VIP Pop-up',
        profile: { data: { type: 'profile', attributes: {
          email: val,
          properties: { signup_source: 'Halloween-VIP 2026' },
          subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
        } } }
      }, relationships: { list: { data: { type: 'list', id: root.getAttribute('data-list') } } } } };
      fetch('https://a.klaviyo.com/client/subscriptions?company_id=' + encodeURIComponent(root.getAttribute('data-company')), {
        method: 'POST',
        headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2024-10-15' },
        body: JSON.stringify(payload)
      }).then(function(r){
        if (r.status === 202 || r.ok) {
          var st = read(); st.done = Date.now(); write(st);
          track('signup');
          view('done'); submitBtn.disabled = false;
          var b = root.querySelector('.exchw-vip__after .exchw-vip__btn'); if (b) { b.focus(); }
        } else { throw new Error(r.status); }
      }).catch(function(){ err.hidden = false; submitBtn.disabled = false; });
    });

    /* Andere Klaviyo-Pop-ups (Insider) schliessen, solange die Halloween-Aktion laeuft */
    var suppress = (root.getAttribute('data-suppress') || '').split(',');
    window.addEventListener('klaviyoForms', function(e){
      var d = e.detail || {};
      if (d.type !== 'open' || !d.formId || isNaN(start) || isNaN(end) || Date.now() < start || Date.now() >= end) { return; }
      var hit = false;
      for (var i = 0; i < suppress.length; i++) { if (suppress[i].replace(/\s/g, '') === d.formId) { hit = true; } }
      if (!hit) { return; }
      window.setTimeout(function(){
        var f = document.querySelector('form[data-testid="klaviyo-form-' + d.formId + '"]');
        var dlg = f && f.closest('[role="dialog"]');
        var x = dlg && dlg.querySelector('.klaviyo-close-form');
        if (x) { x.click(); }
      }, 50);
    });

    if (design) {
      document.addEventListener('shopify:section:select', function(e){ if (e.detail && e.detail.sectionId === sid) { view('form'); open(); } });
      document.addEventListener('shopify:section:deselect', function(e){ if (e.detail && e.detail.sectionId === sid) { close(); teaser.hidden = true; } });
      return;
    }
    window.addEventListener('click', onGateClick, true);
    if (force || window.location.hash === '#insider' || (gated() && isGatePath(window.location.pathname))) { view('form'); open(true); return; }
    if (!auto) { return; }

    var now = Date.now();
    if (isNaN(start) || isNaN(end) || now < start || now >= end || fromMail) { return; }
    var state = read();
    if (state.done) { return; }
    if (state.closed && now - state.closed < snooze) { teaser.hidden = false; return; }
    armed = true; window.setTimeout(preload, 2500);
    armTimer = window.setTimeout(go, delay * 1000);
    window.addEventListener('scroll', onScroll, { passive: true });
    document.documentElement.addEventListener('mouseleave', onLeave);
  }

  function boot(){
    var els = document.querySelectorAll('.exchw-vip');
    for (var i = 0; i < els.length; i++) { init(els[i]); }
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
  document.addEventListener('shopify:section:unload', function(e){
    if (!e.detail) { return; }
    var old = document.querySelectorAll('.exchw-vip[data-bound]');
    for (var i = 0; i < old.length; i++) { if (old[i].getAttribute('data-sid') === e.detail.sectionId && old[i].parentNode) { old[i].parentNode.removeChild(old[i]); } }
  });
})();
